<template>
    <component
        :is="redirect"
        v-model="form"
        :youdian="youdian"
        :buzu="buzu"
        :wjxw="wjxw"
        @close="cancleHandler"
    ></component>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: {
        FormPingjia: () => import('./components/form'),
        DetailPingjia: () => import('./components/detail')
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        form: {},

        redirect: '',
        pjmodel:'',
        youdian: [],
        buzu: [],
        wjxw: []
    }),
    methods: {

    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/zjpj.json`, this.data, data => {
            var model = clone(data.pjmodel);
            model.pwhcycode = data.model.pwhcycode;
            model.cqjgid = data.model.cqjgid;
            model.zjname=data.model.zjname;
            model.e_gzdw=data.model.e_gzdw;
            model.e_pwhzw=data.model.e_pwhzw;
            this.form = model;
       
            if(JSON.stringify(data.pjmodel) === '{}') {
                this.redirect = 'form-pingjia';
            } else {
                this.redirect = 'detail-pingjia';
            };

            this.jspDataInit(data, ['youdian', 'buzu', 'wjxw']);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
